<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group [title]="'wbo.email-setting.edit.formation.details'" [formControlNames]="''">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column *ngIf="!(Config.EMAIL_HOST | stringConfig) || !model.data.useSystemSettings || (Config.EMAIL_ALLOW_OVERRIDE_ADDRESS | booleanConfig)">
                        <wbo-text-edit-control formControlName="emailAddress"
                                               [overrideRequired]="!model.data.useSystemSettings || !model.data.systemEmailAddress"
                                               [(ngModel)]="model.data.emailAddress"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="Config.EMAIL_HOST | stringConfig">
                <fui-two-columns>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="useSystemSettings"
                                                   [overrideRequired]="!model.data.useSystemSettings"
                                                   [(ngModel)]="model.data.useSystemSettings"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <ng-container *ngIf="!(Config.EMAIL_HOST | stringConfig) || !model.data.useSystemSettings">
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-text-edit-control formControlName="emailUsername"
                                                   [overrideRequired]="!model.data.useSystemSettings"
                                                   [(ngModel)]="model.data.emailUsername"></wbo-text-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-password-edit-control formControlName="emailPassword"
                                                       [overrideRequired]="!model.data.useSystemSettings"
                                                       [(ngModel)]="model.data.emailPassword"></wbo-password-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-text-edit-control formControlName="emailHost"
                                                   [overrideRequired]="!model.data.useSystemSettings"
                                                   [(ngModel)]="model.data.emailHost"></wbo-text-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-numeric-edit-control formControlName="smtpPort"
                                                      [overrideRequired]="!model.data.useSystemSettings"
                                                      [(ngModel)]="model.data.smtpPort"></wbo-numeric-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-checkbox-edit-control formControlName="smtpAuth"
                                                       [overrideRequired]="!model.data.useSystemSettings"
                                                       [(ngModel)]="model.data.smtpAuth"></wbo-checkbox-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-checkbox-edit-control formControlName="useTLS"
                                                       [overrideRequired]="!model.data.useSystemSettings"
                                                       [(ngModel)]="model.data.useTLS"></wbo-checkbox-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
            </ng-container>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
